export const getExtension = (filename: string) => {
  if (filename !== '' && filename !== undefined) {
    var parts = filename.split('.')
    return parts[parts.length - 1]
  }
  return ''
}

export const isImage = (filename: any) => {
  var ext = getExtension(filename)
  switch (ext.toLowerCase()) {
    case 'jpg':
    case 'jpeg':
    case 'gif':
    case 'bmp':
    case 'png':
      return true
  }
  return false
}

export const isPdf = (filename: string): boolean => {
  var ext = getExtension(filename)
  switch (ext.toLowerCase()) {
    case 'pdf':
      return true
  }
  return false
}

export const ConstAnnotationType = {
  UserDetails:'User details',
  UserGroup:'User group',
  DateAndTime:'Date & Time',
  Permissions:'Permissions',
  Other:'Other',
}

export const ConstAnnotationTypeId = {
  DevUserDetails:'D206CED9-FED6-4E0F-9800-17423DD540F1',
  DevUserGroup:'1CD4D017-2C1A-44AD-9318-E0C333593AAA',
  DevDateAndTime:'03F0D3F5-FA02-49A4-A6AB-182EEEED1675',
  DevPermissions:'005AF1FC-1E8B-42B1-8380-991F5C5605B2',
  DevOther:'E407B454-4A98-4BC5-9938-985C0877B52B',

  ImplUserDetails:'8D714597-F791-44F8-816B-422A42ABFCEB',
  ImplUserGroup:'115B07FE-B7C0-4C3A-BE55-507F133EDE10',
  ImplDateAndTime:'8431EAE7-28CB-4C4C-892A-0B0C2D6B9F7A',
  ImplPermissions:'8727FDAA-65ED-4E1A-8EF3-789B661376FD',
  ImplOther:'F8AE7963-AA9A-4784-A34E-D40A9D0C35CB',
}